export * from './absences/absences.component';
export * from './absences-new/absences-new.component';
export * from './dashboard/dashboard.component';
export * from './hours-worked/hours-worked.component';
export * from './login/login.component';
export * from './logout/logout.component';
export * from './maintenance/maintenance.component';
export * from './my-hours/my-hours.component';
export * from './requests/requests.component';
export * from './requests-new/requests-new.component';
export * from './releasenotes/releasenotes.component';



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/dialogs/index.ts